// Module
var code = `<div class="product-card-body">
    <div class="back">
        <div class="head">
            <div class="logo{{#if !pictureUrl}} default-logo{{/if}}">
                {{#if pictureUrl}}
                    <terceraPictureBox imageUrl="{{.pictureUrl}}" component_style="product-logo" />
                {{else}}
                    <svg>
                        <use xlink:href="assets/webdesktop/web-desktop-sprite.svg#entitlement_system_default_image"></use>
                    </svg>
                {{/if}}
            </div>
        </div>        
        <div class="product-name {{#if .webkitMod}}product-name-webkit-mod{{/if}}" as-tooltip="nameProductTextTooltip">{{.nameProductText}}</div>
        <div class="product-value">
            <div class="product-value-price1">
                <span class="product-value-bigText">{{.valueProductTextBig}}</span>
                <span class="product-value-smallText">{{.valueProductTextSmall}}</span>
            </div>

            <div class="product-value-price2">
                <span class="product-value-bigText">{{.valueProductTextBig2}}</span>
                <span class="product-value-smallText">{{.valueProductTextSmall2}}</span>
            </div>
            <div class="product-value-tooltip" as-tooltip="labelProductText"></div>
        </div>
    </div>
    <div class="button-ordertype-info{{#if !visibleInfoBtn}} hidden{{/if}}" as-tooltip="infoBtnTooltip">
        <svg>
            <use xlink:href="assets/webdesktop/web-desktop-sprite.svg#infotool"></use>
        </svg>
    </div>
    {{#if .isProcessing}}
        <div>
            <terceraButton terceraButtonStyle="js-button-products-cancel-subscribe-request" text="{{.buttonCancelSubscribeRequestText}}" on-btnClick="cancelSubscribeRequest" tooltip="{{RequestInfoTooltip}}" />
        </div>
    {{else}}
        {{#if .isActive}}
            {{#if .IsUnsubscribeAllowed}}
            <div class="js-button-products-unsubscribe" on-click="unsubscribeClick">
                <span class="js-button-text-products-sub" as-tooltip="RequestButtonsTooltip">{{.buttonSubscribedText}}</span>
                <span class="js-button-text-products-unsub" as-tooltip="RequestButtonsTooltip">{{.buttonUnsubscribeText}}</span>
            </div>
            {{/if}}
        {{else}}
            <div>
                <terceraButton terceraButtonStyle="js-button-products-subscribe" text="{{.buttonSubscribeText}}" tooltip="{{RequestButtonsTooltip}}" on-btnClick="subscribeClick" />
            </div>
        {{/if}}
    {{/if}}
</div>`;
// Exports
export default code;